
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#08C1AB","d":"M40.438 23.247a4 4 0 014.458-3.482l12.58 1.546a4 4 0 013.482 4.458l-.276 2.248-20.827-.034.583-4.736z"}}),_c('path',{attrs:{"fill":"#9FFCEA","fill-rule":"evenodd","d":"M26.074 10.611a4 4 0 00-4.566 3.352l-1.484 9.773a4 4 0 003.954 4.6H37.66l.667-4.31a7.001 7.001 0 016.646-5.927l.078-.528a4 4 0 00-3.345-4.543L26.074 10.61z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"#0AA89D","fill-rule":"evenodd","d":"M19 31.156a9 9 0 00-9 9V61a9 9 0 009 9h42a9 9 0 009-9v-7.29h-7.582a3.132 3.132 0 110-6.265H70v-7.29a9 9 0 00-9-9H19z","clip-rule":"evenodd"}})])
          )
        }
      }
    